// GoatCounter custom event tracking
export const trackEvent = (eventName) => {
  if (window.goatcounter && window.goatcounter.count) {
    window.goatcounter.count({ path: eventName, event: true });
  }
};

// Dismiss state management with cooldown
export const isDismissed = (key, cooldownDays = 7) => {
  try {
    const stored = localStorage.getItem(`promo_dismiss_${key}`);
    if (!stored) return false;
    const { expiry } = JSON.parse(stored);
    if (Date.now() > expiry) {
      localStorage.removeItem(`promo_dismiss_${key}`);
      return false;
    }
    return true;
  } catch {
    return false;
  }
};

export const setDismissed = (key, cooldownDays = 7) => {
  try {
    const expiry = Date.now() + cooldownDays * 24 * 60 * 60 * 1000;
    localStorage.setItem(`promo_dismiss_${key}`, JSON.stringify({ expiry }));
  } catch {
    // localStorage not available
  }
};

// Session-based dismiss (per-session only)
export const isSessionDismissed = (key) => {
  try {
    return sessionStorage.getItem(`promo_session_${key}`) === 'true';
  } catch {
    return false;
  }
};

export const setSessionDismissed = (key) => {
  try {
    sessionStorage.setItem(`promo_session_${key}`, 'true');
  } catch {
    // sessionStorage not available
  }
};

// Station view count tracking (session-based)
export const getSessionViewCount = () => {
  try {
    return parseInt(sessionStorage.getItem('station_view_count') || '0', 10);
  } catch {
    return 0;
  }
};

export const incrementSessionViewCount = () => {
  try {
    const count = getSessionViewCount() + 1;
    sessionStorage.setItem('station_view_count', String(count));
    return count;
  } catch {
    return 0;
  }
};
